import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import {
  cancelEducationalAdvisorBatchParticipation,
  resetCancelEducationalAdvisorBatchParticipation,
} from "@academy-context/write/application/use-cases/educational-advisor/batch-participation-cancellation/cancel-educational-advisor-batch-participation";

const initialState: ProcessingState = { processing: "idle" };

export const cancelEducationalAdvisorBatchParticipationReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(cancelEducationalAdvisorBatchParticipation.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(cancelEducationalAdvisorBatchParticipation.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(cancelEducationalAdvisorBatchParticipation.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetCancelEducationalAdvisorBatchParticipation, () => {
    return initialState;
  });
});
